import { render, staticRenderFns } from "./contractorsAdd.vue?vue&type=template&id=f385f64a&scoped=true"
import script from "./contractorsAdd.vue?vue&type=script&lang=js"
export * from "./contractorsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f385f64a",
  null
  
)

export default component.exports